import { LatestData } from "@station/domain/models/latest-data.model";
import type { StationRepository } from "@station/domain/repositories/station.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class LatestDataGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.StationRepository)
        private readonly stationRepository: StationRepository,
    ) {}

    async execute(stationId: string): Promise<LatestData[]> {
        const latestDataResult =
            await this.stationRepository.latestData(stationId);

        if (latestDataResult.isErr()) {
            throw new Error("Error getting spatial levels");
        }

        return latestDataResult.unwrapOr([]);
    }
}
